import { render, staticRenderFns } from "./SelectAreaRestriction.vue?vue&type=template&id=2a7f528f&"
import script from "./SelectAreaRestriction.vue?vue&type=script&lang=js&"
export * from "./SelectAreaRestriction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports